module.exports = __webpack_public_path__ + "img/06招租.da8e1301.jpg";